<template>
  <div style="display: flex;">
    <input type="radio" :name="label" :id="key" :checked="isChecked" @click="selectRadio(label)"/><span style="margin: 0 5px;"><slot /></span>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, reactive, computed, toRefs } from "vue";
import { RadioGroup } from './RadioGroup.vue';

export default defineComponent({
  name: "VRadio",
  props: {
    key: {
      default: null,
      type: [String, Number]
    },
    label: {
      default: null,
      type: [String, Number]
    }
  },
  setup(props) {
    const radios = inject<RadioGroup>(
      'radios',
      {
        state: reactive({
          value: null
        }),
        selectRadio: () => {}
      }
    );
    const state = reactive({
      isChecked: computed(() => radios.state.value === props.label)
    });
    function selectRadio(val) {
      radios.selectRadio(val);
    }
    return {
      ...toRefs(state),
      radios,
      selectRadio
    };
  }
});
</script>

<style scoped>
.tab {
  padding: 10px 20px;
}
.active {
  border-width: 0px;
  border-bottom-width: 2px;
  border-style: solid;
  border-color: black;
}
</style>